export function inputChange(setValue) {
	return (e) => setValue(e.target.value);
}
